import { handleActions, createAction } from 'redux-actions';
import { getDataProvider } from '../../data-providers';

export const getFacebookProfileData = createAction('GET_FACEBOOK_PROFILE', () => {
  return getDataProvider().getUserFacebookProfile();
});

export default handleActions({
  [`${getFacebookProfileData}_PENDING`]: (state) => {
    return Object.assign({}, state, {
      waitingForResponseFromNative: true,
      name: '',
      email: '',
      birthday: '',
      userId: '',
      accessToken: ''
    });
  },
  [`${getFacebookProfileData}_FULFILLED`]: (state, action) => {
    const { name = '', gender, email = '', birthday = '', id = '', accessToken = '' } = action.payload;

    return Object.assign({}, state, {
      waitingForResponseFromNative: false,
      name: name,
      gender: gender,
      email: email,
      birthday: birthday,
      userId: id,
      accessToken: accessToken
    });
  },
  [`${getFacebookProfileData}_REJECTED`]: (state) => {
    return Object.assign({}, state, { waitingForResponseFromNative: false });
  }
}, { waitingForResponseFromNative: false, name: '', email: '', birthday: '', userId: '' });
